import { render, staticRenderFns } from "./editList.vue?vue&type=template&id=25362bbd&scoped=true"
import script from "./editList.vue?vue&type=script&lang=js"
export * from "./editList.vue?vue&type=script&lang=js"
import style0 from "./editList.vue?vue&type=style&index=0&id=25362bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25362bbd",
  null
  
)

export default component.exports